import React from 'react';
import { bookData } from '../data/mockData';
import { Quote } from 'lucide-react';

const QuotesSection = () => {
  return (
    <section className="py-24 lg:py-32 bg-[#1a1c1b] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#d9fb06] opacity-5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#3f4816] opacity-10 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="mb-6 inline-block">
            <span className="caption text-[#d9fb06] bg-[#3f4816] px-4 py-2 rounded-full">
              FRASES DESTACADAS
            </span>
          </div>
          
          <h2 className="heading-2 text-[#d9fb06] mb-6">
            Reflexiones que Marcan la Diferencia
          </h2>
        </div>

        {/* Quotes Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {bookData.quotes.map((quote, index) => (
            <div
              key={index}
              className="relative bg-[#302f2c] border border-[#3f4816] rounded-lg p-8 lg:p-10 hover:border-[#d9fb06] transition-all duration-300 group"
            >
              {/* Quote icon */}
              <div className="absolute top-6 right-6 opacity-20 group-hover:opacity-40 transition-opacity">
                <Quote className="text-[#d9fb06]" size={48} />
              </div>

              {/* Quote text */}
              <div className="relative z-10">
                <p className="body-medium text-[#dfddd6] mb-4 italic leading-relaxed">
                  "{quote.text}"
                </p>
                
                {/* Context */}
                <div className="flex items-center gap-2">
                  <div className="w-8 h-1 bg-[#d9fb06]"></div>
                  <span className="caption text-[#888680]">
                    {quote.context}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuotesSection;
